import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../../services/analytics.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-card-zone-utilization',
  templateUrl: './card-zone-utilization.component.html',
  styles: [`
    .progress-bar-container {
      background-color: #edf2f7;
      border-radius: 0.25rem;
      height: 0.5rem;
      overflow: hidden;
    }
    .progress-bar-fill {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      white-space: nowrap;
      transition: width 0.3s ease;
    }
    .progress-bar-fill.green { background-color: #48bb78; }
    .progress-bar-fill.yellow { background-color: #ecc94b; }
    .progress-bar-fill.red { background-color: #f56565; }
  `]
})
export class CardZoneUtilizationComponent implements OnInit, OnDestroy {
  zoneData: any[] = [];
  subscription: Subscription;
  loadingSubscription: Subscription;
  loading = false;
  error = false;
  
  constructor(private analyticsService: AnalyticsService) { }

  ngOnInit(): void {
    // Subscribe to analytics service loading state
    this.loadingSubscription = this.analyticsService.loading$
      .subscribe(loading => {
        this.loading = loading;
      });

    this.subscription = this.analyticsService.getZoneUtilization()
      .subscribe(
        data => {
          
          // Ensure utilizationPercent is a valid number between 0-100
          this.zoneData = data.map(zone => {
            const percent = parseFloat(zone.utilizationPercent) || 0;
            const result = {
              ...zone,
              utilizationPercent: Math.max(0, Math.min(100, percent)) // Clamp between 0-100
            };
            return result;
          });
          
          this.error = false;
        },
        err => {
          console.error('Error loading zone utilization data:', err);
          this.error = true;
        }
      );
  }
  
  // Helper method to safely get percentage for slider
  getSliderWidth(percent: number): number {
    if (isNaN(percent) || percent === null || percent === undefined) {
      return 0;
    }
    // Ensure small percentages (like 6.5%) are still visible by setting a minimum width
    const calculatedPercent = Math.max(0, Math.min(100, percent));
    return calculatedPercent < 1 ? 1 : calculatedPercent; // Minimum width of 1% for visibility
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
